module.exports = {
    customer: 'senler',
    assets: { logo: 'logo.svg' }
    
};